// Module
var code = "<react-component name=\"BulkSendWaivers\"></react-component>\n";
// Exports
module.exports = code;